import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { ONBOARDING_VIEWS_MAP, STEPS_TO_SHOW_EXIT_BTN, TEXTS } from '../consts/consts';
import Button from '../../../../generic-components/Button';
import Icon from '../../../../generic-components/Icon';
import closeIcon from '../../../../assets/svg/exit-icon-v2.svg';
import { InvoicesContext } from '../../contexts/InvoicesContext';

interface IProps {
  activeStep: number;
  handleActiveStep: (stepNumber: number) => void;
}

export const NavChildren = ({ activeStep, handleActiveStep }: IProps) => {
  const invoiceContext = useContext(InvoicesContext);
  const { t } = useTranslation();
  const handleClose = () => {
    if (invoiceContext.initialObStep) {
      invoiceContext.clearInitialStep();
    } else {
      handleActiveStep(ONBOARDING_VIEWS_MAP.INTRO);
    }
  };
  return (
    <div className='w-full bg-bw00 flex justify-between'>
      {STEPS_TO_SHOW_EXIT_BTN.includes(activeStep) ? (
        <Button
          onClick={handleClose}
          className='rounded-[50%] w-[28px] h-[28px] hover:bg-bw02 p-[3px]'
          id='closeWizard'
          childElement={<Icon className='w-full' src={closeIcon} />}
        />
      ) : (
        <div />
      )}
      <h1 className='font-metric text-bw08 text-xl'>{t(TEXTS.NAV_FLOW_TITLE)}</h1>
      <div />
    </div>
  );
};
